import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { rewardType } from "../list/RewardTypeList";
import { apiClient } from "../../../../../utils/apiClient";
import { setSnackbarDetails } from "../../../../../redux/AuthReducer/AuthSlice";
import DeleteModal from "../../../../../components/delete-modal/DeleteModal";

type deleteRewardTypeProps = {
  isOpen: boolean;
  details: rewardType | null;
  refreshList: (signal: AbortSignal) => Promise<void>;
  onClose: () => void;
};

const DeleteRewardType: React.FC<deleteRewardTypeProps> = ({
  isOpen,
  details,
  refreshList,
  onClose,
}) => {
  const dispatcher = useDispatch();

  //using the following state to show the btnLoader when user create the data
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  const handleDelete = async (e: React.FormEvent) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      let controller = new AbortController();
      await apiClient.delete(`/reward-type/${details?.id}`, {
        signal: controller?.signal,
      });
      await refreshList(controller?.signal);
      dispatcher(
        setSnackbarDetails({
          type: "success",
          message: "Reward Type deleted succesfully!",
        }),
      );
      onClose();
    } catch (error: any) {
      dispatcher(
        setSnackbarDetails({
          type: "error",
          message:
            error?.response?.data?.data ?? "error in deleting the Reward!",
        }),
      );
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div>
      <DeleteModal
        titleHeader="Delete Reward Type"
        type="delete"
        title={details?.name}
        isOpen={isOpen}
        btnLoader={btnLoading}
        handleDelete={handleDelete}
        onClose={onClose}
      />
    </div>
  );
};

export default DeleteRewardType;
